import peraWalletClient from './perawallet'
import myAlgoWalletClient from './mywalgowallet'
import algoSignerClient from './algosigner'
import { PROVIDER_ID } from '../constants'

const clients = {
  [PROVIDER_ID.PERA_WALLET]: peraWalletClient,
  [PROVIDER_ID.MYALGO_WALLET]: myAlgoWalletClient,
  [PROVIDER_ID.ALGO_SIGNER]: algoSignerClient
}

export default clients
